import { render, staticRenderFns } from "./UpgradeToSeniorMember.vue?vue&type=template&id=63cb2e12"
import script from "./UpgradeToSeniorMember.vue?vue&type=script&lang=js"
export * from "./UpgradeToSeniorMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports